export default "__VITE_ASSET__DuFUOAOE__"